import useSignIn from 'containers/authentication/useSignIn'
import useConnectProvider from 'containers/authentication/useConnectProvider'
import useStorage from 'containers/useStorage'
import useQuery from 'containers/useQuery'
import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'

const MicrosoftRedirect = () => {
    const code = useQuery().get('code')
    const history = useHistory()
    const storage = useStorage()
    // The code is single-use: redeeming it a second time always fails
    const started = useRef(false)

    const {
        signInError,
        signInWithMicrosoft,
      } = useSignIn()

    const { connectProvider } = useConnectProvider()

    useEffect(() => {
        if (started.current) return
        started.current = true

        // Check if this is a provider connection flow
        const intent = localStorage.getItem('oauth_intent')
        const provider = localStorage.getItem('oauth_provider')
        const isConnecting = intent === 'connect_provider' && provider === 'microsoft'

        if (isConnecting) {
          // Clear intent flags, also on cancel, or the next sign-in would be taken for a connection
          localStorage.removeItem('oauth_intent');
          localStorage.removeItem('oauth_provider');
        }

        // No code means the user cancelled or Microsoft refused consent
        if (!code) {
          if (isConnecting) {
            history.push('/settings/providers?error=connection_failed')
          } else {
            history.push({ pathname: '/sign-in', state: { microsoftError: 'Microsoft sign-in was cancelled.' } })
          }
          return
        }

        if (isConnecting) {
          // Call provider connection endpoint
          (async () => {
            const success = await connectProvider({ microsoft_code: code })
            if (success) {
              // Redirect back to settings
              const returnUrl = storage.getUrlWhenLoggedIn()
              storage.removeUrlWhenLoggedIn()
              history.push(returnUrl || '/settings/providers')
            } else {
              // Show error
              history.push('/settings/providers?error=connection_failed')
            }
          })()
          return
        }

        // Normal sign-in flow; failures are handled below once signInError is set
        (async () => {
          if (await signInWithMicrosoft({ microsoft_code: code })) {
            history.push('/')
          }
        })()
    }, [])

    useEffect(() => {
        if (!signInError.server) return

        if (signInError.server === "Merge Required") {
          history.push({
            pathname: `/merge-account`,
            // @ts-ignore
            search: `?email=${signInError.details.email}&provider=${signInError.details.provider}&is_google_signin=${signInError.details.is_google_signin}&is_microsoft_signin=${signInError.details.is_microsoft_signin}&is_password_signin=${signInError.details.is_password_signin}`,
            // @ts-ignore
            state: { microsoftAccessToken: signInError.details.microsoft_access_token },
          })
        } else if (signInError.server === "No such user") {
          // New Microsoft user: sign up with the token the login attempt already obtained
          history.push({
            pathname: '/sign-up',
            state: { microsoftAccessToken: signInError.details?.access_token },
          })
        } else {
          history.push({ pathname: '/sign-in', state: { microsoftError: 'Microsoft sign-in failed. Please try again.' } })
        }
    }, [signInError])

  return (
    <></>
  )
}

export default React.memo(MicrosoftRedirect)
